module.exports = __webpack_public_path__ + "static/media/txt_cover2.05a77c48.png";